import { render, staticRenderFns } from "./CobranzaMes.vue?vue&type=template&id=2f3cb4d0&"
import script from "./CobranzaMes.vue?vue&type=script&lang=js&"
export * from "./CobranzaMes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CobranzaMes.vue"
export default component.exports